var Shopify=Shopify||{};
Shopify.money_format="${{amount}}";
Shopify.formatMoney=function(t,e){
  if("string"==typeof t){ t=t.replace(".",""); }
  var i="",a=/\{\{\s*(\w+)\s*\}\}/,s=e||this.money_format;
  function r(t,e){return void 0===t?e:t}
  function n(t,e,i,a){
    if(e=r(e,2),i=r(i,","),a=r(a,"."),isNaN(t)||null==t)return 0;
    var s=(t=(t/100).toFixed(e)).split(".");
    return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i)+(s[1]?a+s[1]:"")
  }
  switch(s.match(a)[1]){
    case"amount":i=n(t,2);break;
    case"amount_no_decimals":i=n(t,0);break;
    case"amount_with_comma_separator":i=n(t,2,".",",");break;
    case"amount_no_decimals_with_comma_separator":i=n(t,0,".",",")
  }
  return s.replace(a,i)
};

(function(t,e){
  var i=e(".wishlist-btn"),
      a=e(".wishlist-tile-container"),
      s=e(".wishlist-item-count"),
      r=a.length,
      n=localStorage.getItem("user_wishlist")||[];
  if(n.length>0){ n=JSON.parse(localStorage.getItem("user_wishlist")); }

  // ===============================
  // 🔥 Real-time header update
  // ===============================
// ===============================
// 🔥 Real-time header update
// ===============================
function updateHeader(){
    n = JSON.parse(localStorage.getItem("user_wishlist")) || [];
    var count = n.length;
    var header = e('.site-header__icon.site-header__wishlist.cro-nav-fav');
    var headerCount = header.find('.wishlist-item-count');

    if(headerCount.length){
        if(count > 0){ 
            headerCount.text(count).show(); 
            header.addClass('active'); // 🔥 add active class
        } else { 
            headerCount.text("").hide(); 
            header.removeClass('active'); // 🔥 remove active class
        }
    }
}

  // ===============================
  // Existing wishlist logic
  // ===============================
  var l=function(){
    window.location.href.indexOf("pages/wishlist")>-1 && (function(){
      for(var t=String(n).split(","),i=0;i<t.length;i++){
        var a=t[i];
        "insureship-coverage"!=a && e.getJSON("/products/"+a+".js", function(t){
          var i=t.title,a=t.title,s=t.url,r=t.handle,l=0,c=0,o="";
          t.tags,
          e(t.variants).each(function(t,e){
            var i=e;
            i&&(i.price,i.compare_at_price>i.price?(l=Shopify.formatMoney(i.price,""),c=Shopify.formatMoney(i.compare_at_price,""),o='<span class="ProductItem__Price Price Price--compareAt Text--subdued">'+c+'</span><span class="ProductItem__Price Price Price--highlight Text--subdued">'+l+"</span>"):(l=Shopify.formatMoney(i.price,""),o='<span class="ProductItem__Price Price Price--highlight Text--subdued">'+l+"</span>"))
          });
          var d=t.media,h="";
          e(d).each(function(t,e){ t<1 && (h=('<img class="ProductItem__Image Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[600,700,800,900,1000,1200]" data-sizes="auto" alt="'+a+'" title="'+a+'" data-media-id="'+e.id+'" sizes="410px" src="'+e.src+'"></div>').replace(".jpg","_500x.jpg").replace(".png","_500x.png").replace(".jpeg","_500x.jpeg").replace(".webp","_500x.webp").replace(".gif","_500x.gif")) });
          var u='<div class="img-buttons"><span class="nws-wishlist-btn" data-product-handle="'+r+'" ><a class="action--wishlist tile-actions--btn flex wishlist-btn is-active" href="#" data-product-handle="'+r+'">✕</a></span></div>';
          e(".nws-wishlist-grid").append('<div class="ProductItem nws-wishlist-grid-item"><div class="ProductItem__Wrapper">'+u+'<a href="'+s+'" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage"><div class="AspectRatio AspectRatio--withFallback" style="max-width: 2500px; padding-bottom: 100.0%; --aspect-ratio: 1.0">'+h+'</div></a><div class="ProductItem__LabelList"><div class="ProductItem__Info ProductItem__Info--center"><a href="'+s+'"><h3 class="ProductItem__Title Heading"><div class="ProductMeta__Title Heading u-h7">'+i+'</div></h3></a><div class="ProductItem__PriceList  Heading">'+o+'</div><a href="'+s+'" class="Button Button--primary Button--full" >View Product</a></div></div></div>');
          
          // 🔥 Bind remove button inside wishlist page with header update
          e(".wishlist-grid .nws-wishlist-grid .nws-wishlist-btn").off("click").on("click", function(){
            var t = e(this).attr("data-product-handle");
            n = e.grep(n,function(e){ return e != t });
            localStorage.setItem("user_wishlist", JSON.stringify(n));
            e(this).closest('.ProductItem__Wrapper').parent().hide();
            updateHeader(); // 🔥 update header immediately
          });
        });
      }
      ""!=String(n)&&(r=1)
    })();
    e(".wishlist-loader").fadeOut(2e3,function(){ e(".wishlist-grid").addClass("is_visible"); e(".wishlist-hero").addClass("is_visible"); 0==r?e(".wishlist-grid--empty-list").addClass("is_visible"):e(".wishlist-grid--empty-list").hide(); })
  };

  var c=function(){
    i.click(function(t){
      t.preventDefault();
      var handle = e(this).attr("data-product-handle");
      if(e(this).hasClass("is-active")){
        var a = n.indexOf(handle); n.splice(a,1); localStorage.setItem("user_wishlist", JSON.stringify(n));
      }else{
        n.push(handle); localStorage.setItem("user_wishlist", JSON.stringify(n));
      }
      e(this).toggleClass("is-active");
      updateHeader(); // 🔥 update header count in real-time
    });
  };

  t.init=function(){
    c();
    i.each(function(){ var t=e(this).attr("data-product-handle"); if(n.indexOf(t)>-1){ e(this).addClass("is-active"); }});
    l();
    updateHeader(); // initial load
  };

  var o=localStorage.getItem("user_wishlist_time");
  e.ajax({type:"GET",url:"/cart.json",dataType:"json",success:function(t){
    if(t.item_count>0){
      if(""==o){
        var i=new Date((new Date).getTime()+7776e5);
        localStorage.setItem("user_wishlist_time",i.getDate())
      }else{
        var a=(i=new Date((new Date).getTime())).getDate(), s=setInterval(function(){
          o==a&&(e.each(t.items,function(t,e){ var i,a; i=e.handle,a=i,n.push(a); localStorage.setItem("user_wishlist",JSON.stringify(n)); console.log(JSON.stringify(n)) }), localStorage.setItem("user_wishlist_time",""), clearInterval(s))
        },1e3)
      }
    }
  }});

})(window.Wishlist=window.Wishlist||{}, jQuery);

